import { NgModule } from '@angular/core';
import { OverlayComponent } from '../overlay/overlay.component';

const COMPONENTS = [OverlayComponent];

@NgModule({
	imports: [],
	exports: COMPONENTS,
	declarations: COMPONENTS
})
class EdAssistUIOverlayModule {}

export { EdAssistUIOverlayModule, OverlayComponent };
